import { Component, Input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { NavigationComponent } from '../navigation/navigation.component';
import { FooterComponent } from '../footer/footer.component';
import { NavHeaderComponent } from '../nav-header/nav-header.component';
import { HeaderComponent } from '../header/header.component';
import { ChatboxComponent } from '../chatbox/chatbox.component';
import { KeycloakService } from 'keycloak-angular';
import { OpsToolbarComponent } from '../../ui/atoms/ops-toolbar/ops-toolbar.component';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    RouterOutlet, 
    NgClass,
    CommonModule,
    NavigationComponent, 
    FooterComponent, 
    NavHeaderComponent, 
    HeaderComponent, 
    ChatboxComponent,
    OpsToolbarComponent,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.css'
})
export class AdminLayoutComponent {

  toggleVal: boolean = false;
  mouseOvered: boolean = false;
  // Ocultar barra global de operaciones en ciertas vistas (ej. POS)
  hideOpsToolbar: boolean = false;

  sidebarToggle(eventData: { toggleVal: boolean }) {
    this.toggleVal = eventData.toggleVal;
  }
  iconHoverToggle(val: any) {
    this.mouseOvered = val;
  }

  currentItem:string = '';
  dashboardTitle(value:any){
    setTimeout(() => {
      this.currentItem = value.title;
    }, 100);
  }

  constructor(private keycloak: KeycloakService, private router: Router) {
    // Establecer visibilidad inicial y reaccionar a cambios de ruta
    this.updateToolbarVisibility(this.router.url || '');
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
      const url = e?.urlAfterRedirects || e?.url || this.router.url || '';
      this.updateToolbarVisibility(url);
    });
  }

  private updateToolbarVisibility(url: string) {
    // Ocultar barra en vistas específicas (POS, Catálogo y Reporte de Ventas)
    const hiddenPrefixes = ['/admin/pos', '/admin/menu-products', '/admin/resto/reportes'];
    this.hideOpsToolbar = hiddenPrefixes.some(prefix => url.startsWith(prefix));
  }

  async logout() {
    try {
      await this.keycloak.logout(window.location.origin);
    } catch (e) {
      console.error('Logout error', e);
    }
  }
}
